import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './style/progressbar.scss';

const stepWidthFallback = 20;
const stepLimit = 50;

/**
 * @class ProgressBar
 * @param {number} activeStep - current steps for progress bar, required
 * @param {number} totalSteps - total steps for progress bar, required
 * @param {number} progressAnswers - array with unseen (null), seen ('') or answered (string) for each step, optional
 * @param {number} action - function that is called when clicking a step, optional
 * @param {number} styleOverrides - object containing the style overrides, required
 * @returns { undefined }
 */
class ProgressBar extends Component {
    constructor(props) {
        super(props);

        this.calculateStepWidth = this.calculateStepWidth.bind(this);

        this.state = {
            stepWidth: 0
        };
    }

    calculateStepWidth() {
        if (document.querySelector('#progressbar')) {

            // todo: figure out why the correction of - 1 is needed in some cases (left in to look at later)
            this.state.stepWidth = (Math.floor(document.querySelector('#progressbar').offsetWidth) - 1) / this.props.totalSteps;
        } else {

            // fallback when no width could be calculated so at least the steps are visible
            this.state.stepWidth = stepWidthFallback;
        }

        this.setState(this.state);
    }

    componentDidMount() {
        this.calculateStepWidth();

        window.addEventListener('resize', () => this.calculateStepWidth());
    }

    componentWillUnmount() {
        window.removeEventListener('resize', () => this.calculateStepWidth(), true);
    }

    render() {
        const { activeStep, totalSteps, progressAnswers, action, styleOverrides } = this.props;
        const progressBarSteps = [];

        if (activeStep >= 0 && totalSteps && progressAnswers && totalSteps <= stepLimit) {

            /* progress bar with indication for unseen/seen/answered and optionally a click action */
            for (let index = 0; index < totalSteps; index++) {

                let colourOverride;
                let classNameForType;
                let onClickEnabled = true;

                switch (progressAnswers[index]) {

                    case null:
                        classNameForType = style.unseen;
                        colourOverride = styleOverrides.stepsTypeGhosted; // default: grey
                        onClickEnabled = false;
                        break;

                    case '':
                        classNameForType = style.unanswered;
                        colourOverride = styleOverrides.mainBg; // default: white
                        break;

                    default:
                        classNameForType = style.answered;
                        colourOverride = styleOverrides.stepsBg; // default: blue
                        break;
                }

                progressBarSteps.push(<li
                    onClick={ () => {
                        if (onClickEnabled && action) {
                            action(index);
                        }
                    }}
                    className={ `${classNameForType} ${index === activeStep ? style.activeStepItem : ''}` }
                    style={{
                        backgroundColor: colourOverride,
                        width: `${this.state.stepWidth}px`,
                        borderColor: styleOverrides.stepsBg
                    }}
                    key={ index }
                />);
            }
        } else {

            /* simple progress bar */
            for (let index = 0; index < totalSteps; index++) {
                progressBarSteps.push(<li
                    className={ index < activeStep ? style.answered : style.unseen }
                    style={{
                        backgroundColor: index < activeStep ? styleOverrides.stepsBg : styleOverrides.stepsTypeGhosted,
                        width: `${this.state.stepWidth}px`,
                        borderColor: styleOverrides.stepsBg
                    }}
                    key={ index }
                />);
            }
        }

        return (
            <ul className={ style.progressbar } id="progressbar">
                { progressBarSteps }
            </ul>
        );
    }
}

export default ProgressBar;

ProgressBar.propTypes = {
    activeStep: PropTypes.number.isRequired,
    totalSteps: PropTypes.number.isRequired,
    progressAnswers: PropTypes.array,
    action: PropTypes.func,
    styleOverrides: PropTypes.object.isRequired
};
